import http from '../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_CAPITAL_STATE_CONSTRUCTION}/soportes`

export default ({ id }) =>
  http.delete(`${api}/${id}`)
